<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">{{ $t('settings.settingsLabel') }}</span>
        <h3 class="page-title">{{ $t('settings.userGroups.userGroups') }}</h3>
      </d-col>
      <d-col col sm="6" class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/ustawienia')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('settings.backToSettings') }}
        </d-button>
        <d-button theme="success" @click.prevent="$router.push('/ustawienia/grupy-uzytkownikow/nowa')">
          <i class="material-icons">add</i>
          {{ $t('settings.userGroups.addNewUserGroup') }}
        </d-button>
      </d-col>
    </d-row>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">{{ $t('settings.userGroups.groupName') }}</th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(group, index) of groups"
            :key="'group-' + index">
            <td class="align-middle">
              {{ group.name }}
            </td>
            <td
              class="align-middle"
              style="width: 200px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/ustawienia/grupy-uzytkownikow/edycja/' + group.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeGroup(group.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
        </tbody>
        <tbody v-if="groups.length === 0">
          <tr>
            <td
              colspan="3"
              class="text-center">
              {{ $t('settings.userGroups.noUserGroupsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!loaded" class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>
  </d-container>
</template>

<script>
import ListUtils from './../utils/ListUtils.js';

export default {
  name: 'user-groups',
  data() {
    return {
      groups: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      ListUtils.loadItemsData(this, '/users/groups/items', 'groups', { return: 'get' });
    },
    removeGroup (groupID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/users/groups/delete/',
        id: groupID,
        successTitle: this.$t('settings.userGroups.removeUserGroupSuccessTitle'),
        successText: this.$t('settings.userGroups.removeUserGroupSuccessText'),
        confirmTitle: this.$t('settings.userGroups.removeUserGroupConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.userGroups.removeUserGroupErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
